import React from 'react';

import {
  Accordion as ChakraAccordion,
  AccordionItem as ChakraAccordionItem,
  AccordionButton as ChakraAccordionButton,
  AccordionPanel as ChakraAccordionPanel,
  Box,
} from '@chakra-ui/react';
import styled from '@emotion/styled';

import { ArrowRightCircle } from 'assets/assetsV1/iconComponents';

export const Accordion = styled(ChakraAccordion)`
  // & .chakra-accordion__item:last-child {
  //   border: 0;
  // }
  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.25);
  border-radius: 8px;
  overflow: hidden;
`;

export const AccordionItem = styled(ChakraAccordionItem, {
  shouldForwardProp: (prop) => !['isError'].includes(prop),
})(({ theme, ...props }) => ({
  border: 0,
  borderBottom: `1px solid ${props.isError ? theme.colors.feedback.FFE1D9 : theme.colors.neutral.CFD7DF}`,
  borderTop: `${props.isError ? '1px' : '0'} solid ${theme.colors.feedback.FFE1D9}`,
  borderLeft: `${props.isError ? '2px' : '0'} solid ${theme.colors.alerts.negative}`,
  padding: '0',
}));

export const AccordionItem2 = ({ sxProps, ...props }) => (
  <AccordionItem
    sx={{
      button: {
        background: 'white',
      },
      '.chakra-accordion__button': {
        padding: '0px 4px',
      },
      borderColor: '#EBEFF3 !important',
      ...sxProps,
    }}
    {...props}
  />
);

export const AccordionPanel = styled(ChakraAccordionPanel)`
  padding: 0;
  border-top: 1px solid ${({ theme }) => theme.colors.border.CFD7DF};
`;

export const AccordionPanel2 = ({ ...props }) => (
  <AccordionPanel p="0px 4px !important" borderTop="0 !important" borderBottom="none" {...props} />
);

const StyledAccordionButton = styled(ChakraAccordionButton, {
  shouldForwardProp: (prop) => !['isError'].includes(prop),
})(
  ({ theme, ...props }) => `
  display: flex;
  align-items: center;
  justify-content: flex-start;
  background: ${theme.colors.surface.F5F7F9};
  min-height: 48px;
  &:hover {
    background: transparent;
  }
  border-bottom: ${props.isError ? '1px' : '0'} solid ${theme.colors.feedback.FFE1D9};
  padding: 0 16px;
  transform: rotate(0deg);
  svg.toggle-svg {
    transition: transform 100ms;
  }
  &[aria-expanded='true'] {
    svg.toggle-svg {
      transform: rotate(90deg);
    }
    background: white;
  }
  p{
    user-select: text;
  }
`
);

export const AccordionButton = ({ children, ...props }) => (
  <StyledAccordionButton {...props}>
    <Box pl={2} height="28px">
      <ArrowRightCircle className="toggle-svg" mr="12px" fill="transparent" boxSize="16px" color="primary.1565BC" />
    </Box>
    {children}
  </StyledAccordionButton>
);
